import { matchPath, useLocation, useMatch } from 'react-router-dom';

export const RING_BUFFER_PAGE_MATCHES = [
  '/entities/:id/astronaut/overview',
  '/entities/:id/astronaut/events',
  '/entities/:id/astronaut/data-explorer',
  '/entities/:id/astronaut/logs',
] as const;

export type RingBufferPageMatch = (typeof RING_BUFFER_PAGE_MATCHES)[number];

const SETTINGS_PAGE_MATCHES = [
  '/entities/:externalId/astronaut/settings/*',
  '/entities/:externalId/amf/settings/*',
  '/entities/:externalId/vector/settings/*',
] as const;

const FARM_DETAILS_PAGE_MATCH = '/farms/:id';
const VDE_PAGE_MATCH = '/vector/data-explorer/*';
const ENTITY_PAGE_MATCH = '/entities/*';
const ASTRONAUT_PAGE_MATCH = '/astronaut/*';

const usePageMatch = () => {
  const { pathname } = useLocation();

  const isFarmDetailsPage = !!useMatch(FARM_DETAILS_PAGE_MATCH);
  const isVDEPage = !!useMatch(VDE_PAGE_MATCH);
  const isEntityPage = !!useMatch(ENTITY_PAGE_MATCH);
  const isSettingsPage = SETTINGS_PAGE_MATCHES.some((path) =>
    matchPath(path, pathname),
  );

  const ringBufferPageMatch: RingBufferPageMatch | undefined =
    RING_BUFFER_PAGE_MATCHES.find((path) => matchPath(path, pathname));
  const isRingBufferPage = !!ringBufferPageMatch;

  const isAstronautPage = !!useMatch(ASTRONAUT_PAGE_MATCH);

  return {
    isFarmDetailsPage,
    isVDEPage,
    isEntityPage,
    isSettingsPage,

    isRingBufferPage,
    ringBufferPageMatch,

    isAstronautPage,
  };
};

export default usePageMatch;
